export {
    default as Indicator,
    IIndicatorProps,
    TIndicatorColor,
} from './indicator';
